export default "__VITE_ASSET__BvVOAFiZ__"